import type { FagmoblerPublicOmniumProduct } from '@fagmobler/types';
import camelCase from 'just-camel-case';

type propertyKey = FagmoblerPublicOmniumProduct['properties'][0]['key'];

export function translateProperty(key: propertyKey) {
  switch (key) {
    case 'sku':
      return { text: 'varenummer' };

    case 'depth':
      return { text: 'dybde', postfix: 'cm' };

    case 'depth2':
      return { text: 'annen dybde', postfix: 'cm' };

    case 'width':
      return { text: 'bredde', postfix: 'cm' };

    case 'height':
      return { text: 'høyde', postfix: 'cm' };

    case 'weight':
      return { text: 'vekt', postfix: 'kg' };

    case 'length':
      return { text: 'lengde', postfix: 'cm' };

    case 'seatDepth':
      return { text: 'sittedybde', postfix: 'cm' };

    case 'seatHeight':
      return { text: 'sittehøyde', postfix: 'cm' };

    case 'colour':
      return { text: 'farge' };

    case 'clothing':
      return { text: 'stoff' };

    case 'details':
      return { text: 'detaljer' };

    case 'keyProperties':
      return { text: 'egenskaper' };

    case 'assembled':
      return { text: 'montert' };

    case 'warranty':
      return { text: 'garanti' };

    case 'concept':
      return { text: 'konsept' };

    case 'origin':
      return { text: 'opphav' };

    case 'environment':
      return { text: 'miljø' };

    case 'style':
      return { text: 'stil' };

    case 'bedsize':
      return { text: 'liggemål' };
    case 'care':
      return { text: 'Vedlikeholdsinstruksjoner' };
    default:
      return { text: key };
  }
}

export function resolveProperties(
  product: FagmoblerPublicOmniumProduct,
  allowed: propertyKey[] = [],
  disallowed: propertyKey[] = []
) {
  return [
    ...(product?.properties || []),
    { key: 'sku', value: product?.skuId },
  ].filter(({ key, value }) =>
    value && key && allowed.length > 0
      ? allowed.includes(camelCase(key))
      : disallowed.length > 0 && !disallowed.includes(camelCase(key))
  );
}
